import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

import { APP_LIBRARY } from 'constants/urls';

import smart_toy_icon from 'images/teamOverview/smart_toy.svg';

import { useNoDataPlaceholderStyles } from 'components/TeamOverview/components/AiComputeTransactionsCard/styles';

export const NoDataPlaceholder = () => {
  const { classes } = useNoDataPlaceholderStyles();

  return (
    <Box className={classes.root}>
      <img src={smart_toy_icon} alt="smart toy" className={classes.icon} />
      <Box className={classes.textContainer}>
        <Typography className={classes.title}>
          Looks like you haven’t run any AI tools yet.
        </Typography>
        <Typography className={classes.subtitle}>
          Head over to the AI App Library to choose a tool and start your first
          analysis.
        </Typography>
      </Box>
      <Link to={APP_LIBRARY} className={classes.btn}>
        <SearchIcon />
        BROWSE AI TOOLS
      </Link>
    </Box>
  );
};
